module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "wechat-title",
      rawName: "v-wechat-title",
      value: (_vm.$route.meta.title),
      expression: "$route.meta.title"
    }],
    attrs: {
      "id": "online-env"
    }
  }, _vm._l((_vm.dataList), function(item) {
    return _c('div', {
      key: item.key,
      class: ['online', item.key === 'online' ? 'online-bg' : 'env-bg'],
      attrs: {
        "id": item.key
      }
    }, [_c('div', {
      staticClass: "online-container"
    }, [_c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('ul', {
      staticClass: "tag"
    }, _vm._l((item.tags), function(tag, index) {
      return _c('li', {
        key: index,
        class: [item.key === 'online' ? 'li-online' : 'li-env']
      }, [_vm._v(_vm._s(tag))])
    }), 0), _vm._v(" "), _c('p', {
      staticClass: "fit"
    }, [_c('span', {
      staticClass: "icon-chengyuan"
    }), _vm._v(_vm._s(item.applicable))]), _vm._v(" "), _c('p', {
      staticClass: "message",
      domProps: {
        "innerHTML": _vm._s(_vm.filterXSS(item.desc))
      }
    }), _vm._v(" "), _c('div', {
      class: ['process', item.key === 'online' ? 'process-online' : 'process-env']
    }, [_vm._l((item.process), function(step) {
      return [_c('div', {
        key: step.step,
        class: ['step', step.url ? 'hasUrl' : ''],
        on: {
          "click": function($event) {
            return _vm.handleApply(step)
          }
        }
      }, [_c('div', {
        staticClass: "step-count"
      }, [_vm._v(_vm._s(step.step))]), _vm._v(" "), _c('span', {
        staticClass: "step-name"
      }, [_vm._v(_vm._s(step.name))])]), _vm._v(" "), (step.hasNext) ? _c('svg', {
        staticStyle: {
          "width": "20px",
          "height": "20px"
        },
        attrs: {
          "fill": "#C4C6CC",
          "aria-hidden": "true"
        }
      }, [_c('use', {
        attrs: {
          "xlink:href": "#icon-youjiantou"
        }
      })]) : _vm._e()]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "operate"
    }, _vm._l((item.btns), function(btn, index) {
      return _c('div', {
        key: index,
        class: ['btn', btn.name === '立即体验' ? 'online-btn' : 'online-env'],
        on: {
          "click": function($event) {
            return _vm.handleApply(btn)
          }
        }
      }, [_vm._v(_vm._s(btn.name))])
    }), 0), _vm._v(" "), (!Array.isArray(item.videoList)) ? _c('div', {
      staticClass: "video"
    }, [(_vm.isplay) ? _c('div', {
      staticClass: "shade"
    }, [_c('p', [_vm._v("线上环境动画演示")]), _vm._v(" "), _c('div', {
      staticClass: "identify"
    }, [_vm._v("BlueKing")]), _vm._v(" "), _c('img', {
      attrs: {
        "src": require("../../images/online_env/bg.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "tip2"
    }, [_vm._v("最新功能抢先看，手把手教程")]), _vm._v(" "), _c('div', {
      staticClass: "play",
      on: {
        "click": _vm.handlePlay
      }
    }, [_c('span', {
      staticClass: "icon-player",
      staticStyle: {
        "font-size": "32px",
        "padding": "0 15px 0 0px",
        "vertical-align": "middle"
      }
    }), _vm._v("立即观看")]), _vm._v(" "), _c('div', {
      staticClass: "play-desc"
    }), _vm._v(" "), _c('div', {
      staticClass: "f-shade"
    }, [_c('span', {
      staticClass: "icon-player",
      staticStyle: {
        "font-size": "32px",
        "vertical-align": "middle"
      }
    }), _vm._v("\n                        " + _vm._s(item.videoList.desc || '线上环境动画演示') + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "f-shade-desc"
    })]) : _c('video', {
      staticStyle: {
        "width": "100%",
        "height": "100%"
      },
      attrs: {
        "id": "video"
      }
    }, [_c('source', {
      attrs: {
        "src": item.videoList.resource,
        "type": "video/mp4"
      }
    }), _vm._v("\n                    你的浏览器不支持Video标签\n                ")])]) : _c('div', {
      staticClass: "recommended"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('span', [_vm._v("推荐课程")]), _vm._v(" "), _c('p', {
      staticClass: "more",
      on: {
        "click": function($event) {
          return _vm.handleJump(item.videoList[0])
        }
      }
    }, [_vm._v("更多 >")])]), _vm._v(" "), _c('ul', {
      staticClass: "video-list"
    }, _vm._l((item.videoList[1].children), function(video) {
      return _c('a', {
        key: video.name,
        attrs: {
          "href": video.url,
          "target": "_blank"
        }
      }, [(video.resource) ? _c('img', {
        attrs: {
          "src": video.resource,
          "alt": ""
        }
      }) : _c('img', {
        attrs: {
          "src": require("../../images/online_env/bg.png"),
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "identify"
      }, [_vm._v("BlueKing")]), _vm._v(" "), _c('div', {
        staticClass: "name",
        attrs: {
          "title": video.name
        }
      }, [_vm._v(_vm._s(video.name))]), _vm._v(" "), _c('div', {
        staticClass: "play"
      }), _vm._v(" "), _c('span', {
        staticClass: "play-icon icon-player"
      }), _vm._v(" "), _c('div', {
        staticClass: "shade"
      }), _vm._v(" "), _c('div', {
        staticClass: "duration"
      }, [_vm._v(_vm._s(video.extra_info.duration || '--'))])])
    }), 0)])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-59e2ad40!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/online_env/index.vue
// module id = lQwU
// module chunks = 15